// Lightweight per-route SEO hook (updates document.title + meta description)
import { useEffect } from "react";

export default function useSEO({ title, description, path, lang = "pl" }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const setMeta = (selector, attr, content) => {
      if (!content) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, val] = selector.replace(/\[|\]|"/g, "").split("=");
        el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, content);
    };

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);

    if (path) {
      const url = `https://lklog.co${path}`;
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
      setMeta('meta[property="og:url"]', "content", url);
    }

    document.documentElement.lang = lang;
  }, [title, description, path, lang]);
}
